import { useRouter } from 'next/router'

const pathMappings = require('../../pathMapping.json')

/**
 * Maps a canonical (English) route key to its public path for the active locale.
 *
 * Reads the locale from the router rather than from i18n: react-i18next's i18n.language
 * is null during server rendering, which silently made every localized href fall back to
 * its English path in the server HTML and only correct itself after hydration. The router
 * locale is correct on both sides.
 */
const useLocalizedPath = () => {
  const { locale, defaultLocale } = useRouter()

  const getLocalizedPath = (path: string, addSlash: boolean = true): string => {
    const language = locale ?? defaultLocale
    const localizedPath = language ? pathMappings[path]?.[language] : undefined

    if (localizedPath) {
      return addSlash ? `/${localizedPath}` : localizedPath
    }

    return addSlash ? `/${path}` : path
  }

  return getLocalizedPath
}

export default useLocalizedPath
